<template>
    <div v-if="isMounted">
        <div class="vx-row mt-2 mb-5">
            <div class="vx-col w-full">
                <div id="div-with-loading" class="vs-con-loading__container flex flex-center">
                    <vs-button v-if="phone" @click.stop="requestSendNotification" size="small" color="#303f9f">
                        Notificar de llamada al solicitante
                    </vs-button>
                    <vs-button v-else @click.stop="notifPhoneRequired">
                        Notificar de llamada al solicitante
                    </vs-button>
                    <!-- <vs-chip transparent color="primary">
                        <span class="bold text-xs">Notificar de llamada al Solicitante</span>
                    </vs-chip>
                    <vs-button v-if="phone" class="ml-2" size="small" radius icon-pack="feather" icon="icon-send"
                        @click.stop="requestSendNotification"></vs-button>
                    <vx-tooltip
                        v-else
                        color="dark"
                        position="right"
                        text="El solicitante debe contar con un número de teléfono, para utilizar esta función">
                        <vs-button size="small" disabled radius class="ml-2" icon-pack="feather" icon="icon-send"></vs-button>
                    </vx-tooltip> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ApplicantNotificationButton",
    props: {
        userId: { required: true }
    },
    data() {
        return {
            isMounted: false,
            phone: null,
            phoneStatus: null,
            dialCode: null,
            phoneId: null
        }
    },
    async beforeMount() {
        this.getApplicantPhoneData();
    },
    computed: {
        //TODO
    },
    methods: {
        async getApplicantPhoneData() {
            try {
                const res = await axios.get(`/api/v1/userInfo/${this.userId}/getMainPhone`);
                this.phone = res.data.phone;
                this.phoneStatus = res.data.phone_status;
                this.dialCode = res.data.dial_code ? res.data.dial_code : '+52';
                this.phoneId = res.data.phone_id;
                this.isMounted = true;
            }
            catch (e) {
            }
        },
        requestSendNotification(){
            this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title:  "Notificación a Solicitante",
                text: `Se enviará un mensaje de whatsapp al teléfono ${this.phone} para contactar al solicitante ¿Deseas continuar?`,
                acceptText: "Confirmar",
                cancelText: 'Cancelar',
                accept: this.doSendNotification
            });
        },
        async doSendNotification(){
            try {
                this.$vs.loading({
                    container: '#div-with-loading',
                    scale: 0.6
                })
                const payload = {
                    user_id: this.userId
                }
                await axios.post(`/api/notification/send-applicant-call`, payload);
                this.$vs.loading.close('#div-with-loading > .con-vs-loading')
                this.saveSuccessNotif();
            } catch (error) {
                this.$vs.loading.close('#div-with-loading > .con-vs-loading')
                this.failedOperationNotif("Mensaje no enviado", error.response.data);
                console.error(error);
            }
        },
        notifPhoneRequired(){
            this.$vs.notify({
                title: 'Error',
                text: 'El solicitante debe contar con un número de teléfono para utilizar esta función',
                color: 'danger',
                iconPack: 'feather',
                icon: 'icon-alert-circle'
            });
        },
    }
}
</script>

<style scoped>

</style>